import type { ReactNode } from 'react';
import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import { formatDate, formatMoney } from '@/lib/formatUtils';

const isFirstRow = (params: DataTableRenderCellParams) => params.row.stt === '' || params.row.stt === 0;
const renderBoldCell = (params: DataTableRenderCellParams, value: unknown = params.value) => (
  <span style={{ fontWeight: isFirstRow(params) ? 'bold' : 'normal' }}>{value as ReactNode}</span>
);

export const getDataTableColumns = (): DataTableColumn[] => [
  {
    field: 'stt',
    headerName: 'STT',
    width: 60,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 110,
    renderCell: params => renderBoldCell(params, formatDate(params.value as string | Date | null | undefined))
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ',
    width: 120,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ngay_ct0',
    headerName: 'Ngày hóa đơn',
    width: 120,
    renderCell: params => renderBoldCell(params, formatDate(params.value as string | Date | null | undefined))
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 130,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 300,
    flex: 1,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 130,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 250,
    flex: 1,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ma_nvbh',
    headerName: 'Mã NVBH',
    width: 100,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ten_nvbh',
    headerName: 'Tên NVBH',
    width: 180,
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 't_tt',
    headerName: 'Tổng tiền HĐ',
    width: 150,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'tt',
    headerName: 'Đã thu',
    width: 130,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'cl',
    headerName: 'Còn lại',
    width: 130,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'trong_han',
    headerName: 'Trong hạn',
    width: 130,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'qua_han01',
    headerName: 'Quá hạn 1-45 ngày',
    width: 150,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'qua_han02',
    headerName: 'Quá hạn 46-90 ngày',
    width: 160,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'qua_han03',
    headerName: 'Quá hạn 91-135 ngày',
    width: 170,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'qua_han04',
    headerName: 'Quá hạn 136-180 ngày',
    width: 180,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'qua_han05',
    headerName: 'Quá hạn >181 ngày',
    width: 160,
    type: 'number',
    renderCell: params => renderBoldCell(params, formatMoney((params.value as number) || 0))
  },
  {
    field: 'ngay_dh0',
    headerName: 'Ngày đến hạn',
    width: 130,
    renderCell: params => renderBoldCell(params, formatDate(params.value as string | Date | null | undefined))
  },
  {
    field: 'han_tt',
    headerName: 'Hạn thanh toán',
    width: 130,
    renderCell: params => renderBoldCell(params, formatDate(params.value as string | Date | null | undefined))
  },
  {
    field: 'so_ngay',
    headerName: 'Số ngày',
    width: 100,
    type: 'number',
    renderCell: params => renderBoldCell(params)
  },
  {
    field: 'ma_nt',
    headerName: 'Loại tiền',
    width: 100,
    renderCell: params => renderBoldCell(params)
  }
];
